"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.getEventCategory = exports.eventCategoryMap = void 0;
exports.eventCategoryMap = {
    '/global-position': 'accountOverview',
    '/accounts': '/accounts',
    '/cards': 'cardListView',
    '/transfers': 'transfersSubhome',
};
const getEventCategory = (path) => {
    const pageName = Object.keys(exports.eventCategoryMap).find(key => path.endsWith(key));
    return pageName ? exports.eventCategoryMap[pageName] : null;
};
exports.getEventCategory = getEventCategory;
//# sourceMappingURL=tracking.utils.js.map